<template>
  <div>
    <a
      href="javascript:void(0);"
      class="relative block w-full"
      @click="open"
    >
      <img
        :src="item.main_image_big"
        class="w-full"
      >
    </a>

    <span
      class="w-full block"
      v-text="closingTime"
    />
    <i class="far fa-clock text-[.7rem] -mt-0.5" />
    <span
      v-if="item.ending_handled"
      class="inline font-bold"
    >Veiling is afgelopen</span>
    <span
      v-else-if="item.is_ending"
      class="inline font-bold"
    >Veiling toewijzen</span>
    <span
      v-else
      class="inline font-bold"
      v-text="`${timeLeftToText}`"
    />

    <div class="flex mt-3 flex-col">
      <span class="block w-full text-sm">Huidig bod:</span>
      <span
        v-if="item.bids.data.length === 0"
        class="block w-full text-gray-500 text-xs"
      >Door: --</span>
      <span
        v-else
        class="block w-full text-gray-500 text-xs"
      >Door: {{
        item.bids.data[0].name
      }} om {{ item.bids.data[0].time }}</span>
      <span
        v-if="item.bids.data.length === 0"
        class="text-sky-400 text-3xl font-bold mt-3"
      >&euro; --</span>
      <span
        v-else
        class="text-sky-400 text-3xl font-bold mt-3"
        v-text="formatMoney(item.bids.data[0].amount)"
      />
    </div>
  </div>
</template>

<script>
import ProductBase from '../../Mixins/ProductBase';
import Counter from '../../Mixins/Counter';

export default {
  mixins: [ProductBase, Counter],

  emits: ['bid', 'isEnding', 'almostEnding', 'isEnding', 'ended', 'hasWon'],

  data () {

    return {
      timeLeft: this.counter(new Date(this.item.auction_ends_at)),
      closingTime: this.getClosingTime(),
      counterInterval: null,
    };
  },

  computed: {
    timeLeftToText() {
      let hours = this.timeLeft.hours;
      if (this.timeLeft.days > 0) {
        hours += (this.timeLeft.days * 24);
      }

      return `${hours} uur, ${this.timeLeft.minutes} min en ${this.timeLeft.seconds} sec`;
    },
  },

  mounted () {
    this.updateTimer(false);
    this.counterInterval = setInterval(this.updateTimer, 1000);

    this.$echo.channel('auctions')
        .listen('AuctionUpdated', this.handleAuctionUpdatedEvent);
    this.$eventHub.$on('auctions.handlers', this.eventHandlers);
  },

  destroyed () {
    clearInterval(this.counterInterval);
    this.$echo.leaveChannel('auctions');
    this.$eventHub.$off('auctions.handlers', this.eventHandlers);
  },

  methods: {
    handleAuctionUpdatedEvent(event) {
      if (event.auction.id !== this.item.id) {
        return;
      }

      if (event.auction.bids) {
        this.item.bids = event.auction.bids;
      }
      if (event.auction.customer_id) {
        this.item.customer_id = event.auction.customer_id;
      }

      let hasEnded = false;
      if (this.item.ending_handled === false && event.auction.ending_handled === true) {
        hasEnded = true;
      }

      this.item.is_ending = event.auction.is_ending;
      this.item.ending_handled = event.auction.ending_handled;
      this.item.auction_ends_at = event.auction.auction_ends_at;
      this.closingTime = this.getClosingTime();
      this.checkAutoBid();

      if (hasEnded) {
        this.$nextTick(() => this.auctionEnded());
      }
    },

    eventHandlers (event, auctionId, ...args) {
      if (auctionId !== this.item.id) {
        return;
      }

      if (event === 'autobid') {
        this.autoBid = args[0];
      } else if (event === 'favorite') {
        this.item.favorite = true;
      }
    },

    getClosingTime() {
      let closingTime = null;
      const auctionEndsAt = new Date(this.item.auction_ends_at);

      if (this.item.ending_handled) {
        closingTime = `Gesloten om ${this.formatDateDigit(auctionEndsAt.getHours())}:${this.formatDateDigit(auctionEndsAt.getMinutes())}`;
      } else if (auctionEndsAt.getDay() === new Date().getDay()) {
        closingTime = `Sluit vandaag om ${this.formatDateDigit(auctionEndsAt.getHours())}:${this.formatDateDigit(auctionEndsAt.getMinutes())}`;
      } else {
        const date = auctionEndsAt.toISOString().split('T')[0];

        closingTime = `Sluit op ${date} om ${this.formatDateDigit(auctionEndsAt.getHours())}:${this.formatDateDigit(auctionEndsAt.getMinutes())}`;
      }

      return closingTime;
    },

    nextBidAmount () {
      if (this.item.bids.data.length) {
        return this.item.bids.data[0].amount + this.item.minimal_raise;
      }

      return this.item.starting_price;
    },

    updateTimer (dispatchEvents = true) {
      this.timeLeft = this.counter(new Date(this.item.auction_ends_at));

      if (
        dispatchEvents && this.timeLeft.minutes === 0
        && this.timeLeft.seconds > 10 && this.timeLeft.seconds < 60
      ) {
        this.$emit('almostEnding');
      }

      if (
        dispatchEvents && this.timeLeft.minutes === 0
        && this.timeLeft.seconds > 1 && this.timeLeft.seconds < 10
      ) {
        this.$emit('isEnding');
      }

      if (this.timeLeft.seconds < 0) {
        this.item.is_ending = true;
      }
    },

    auctionEnded() {
      this.$emit('ended');
    },
  },
};
</script>
